import { Component, EventEmitter, Input, Output } from '@angular/core';

/**
 * SettingsMenuComponent
 *
 * @export
 * @class SettingsMenuComponent
 * @typedef {SettingsMenuComponent}
 */
@Component({
  selector: 'aup-settings-menu',
  templateUrl: './settings-menu.component.html',
  styleUrls: ['./settings-menu.component.scss'],
  standalone: false,
})
export class SettingsMenuComponent {
  @Input() isMenuExpanded = false;
  @Input() isMobile = false;
  /**
   * Emit event on menu position click
   *
   * @type {EventEmitter<void>}
   */
  @Output() closeDrawerIfMobile: EventEmitter<void> = new EventEmitter();
}
